export default "__VITE_ASSET__BAR2mVXY__"